"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FCI_ERROR = void 0;
const FCI_ERROR = exports.FCI_ERROR = {
  // Major Errors

  /**
   * Server returns an error page or a status code
   * that causes the browser to display a default
   * error page.
   */
  Main: "Main",
  /**
   * Connection failure on initial connection to
   * stack or abort of existing connection that
   * causes the browser to display a connection
   * error page.
   */
  Connection: "Connection",
  /**
   * Errors on AJAX or Mobile API data requests
   * that result in full pages/screens, panes, or
   * tabs that contain no content.
   */
  EmptyContent: "Empty Content",
  /**
   * Pages, Screens, AJAX or Mobile API requests
   * that exceed the maximum reasonable request
   * time, regardless of whether they actually
   * timeout.
   */
  Timeout: "Timeout",
  /**
   * Important broken links or other clickable UI
   * elements that do not function when clicked on.
   */
  Navigation: "Navigation",
  /**
   * Supplementary content, non-essential UI
   * elements, or fallback treatments that obviously
   * display they are broken.
   */
  Supplemental: "Supplemental",
  /**
   * Element that is important to completing a task
   * is missing.
   */
  MissingElement: "Missing Element",
  /**
   * Errors on essential AJAX or Mobile API POST,
   * PUT, or DELETE requests.
   */
  Action: "Action",
  // Minor Errors

  /**
   * Incomplete but not empty list that is unlikely
   * to be noticed by a user.
   */
  PartialContent: "Partial Content",
  /**
   * Substitution of fallback data not likely to be
   * noticed by a user.
   */
  TransparentSubstitution: "Transparent Substitution",
  /**
   * Non working convenience features such as
   * typeahead, hover, form validation.
   */
  Convenience: "Convenience",
  /**
   * Supplementary content not available
   * */
  MissingSupplContent: "Missing Supplemental Content",
  // Transparent or Possible Errors

  /**
   * AJAX or Mobile API requests that exceed the
   * maximum reasonable request time, regardless of
   * whether they actually timeout. This should only
   * be used when it cannot be determined with
   * certainty that a slow request is really a
   * problem for the customer. (e.g. like when F5
   * is sending the FCI event and has no
   * X-FCI-ErrorType from the client). If it is a
   * problem for the customer, then Timeout should
   * be used instead.
   */
  PossibleTimeout: "Possible-Timeout",
  /**
   * Errors on AJAX or Mobile API data requests
   * that result in full pages/screens, panes, or
   * tabs that contain no content. This is a guess -
   * it should only be used when an error happens
   * and it can't be determined exactly what the
   * problem is for the customer. In this case, the
   * guess is that an error on an API GET at the
   * front end probably means some content could not
   * be populated.
   */
  PossibleEmptyContent: "Possible-Empty-Content"
};